<template>
  <b-modal title="Elétrica do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-form-group label-cols="1" label="Elétrica:" label-align="center">
            <b-form-textarea v-model="template.eletrica" rows="8"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Condições Elétricas</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.eletricos" :fields="fields.item_eletrico"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="2" label-align="right">
            <b-form-input id="descricao" v-model="eletrico.descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Avaliação:" label-for="avaliacao" label-cols="2" label-align="right">
            <b-form-input id="avaliacao" v-model="eletrico.avaliacao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="add()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="del()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Imagens da Inspeção Elétrica</b-alert>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Imagens:" label-cols="2" label-align="right">
            <b-form-file multiple accept=".jpg" v-model="files" placeholder="Solte as imagem aqui .jpg" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-checkbox v-model="template.displayEletrica" name="check-button" switch class="pt-2">
            Exibir Página <b>{{ template.displayEletrica }}</b>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Cancel</b-button>
      <b-button variant="primary" @click="carregar()">OK</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ModalDeLaudoTecnicoEletrico",

  components: {},

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
      fields: new ReportFields(),
      eletrico: { item: "", descricao: "", avaliacao: "" },
      files: new Array(),
    };
  },

  methods: {
    formatNames(files) {
      return files.length === 1 ? files[0].name : `${files.length} files selected`;
    },

    carregar() {
      for (var i = 0; i < this.files.length; i++) {
        const reader = new FileReader();
        const blob = new Blob([this.files[i]]);
        reader.readAsDataURL(blob);
        switch (i) {
          case 0:
            reader.onload = (e) => {
              this.template.imgSixthPageA = e.target.result;
            };
            break;
          case 1:
            reader.onload = (e) => {
              this.template.imgSixthPageB = e.target.result;
            };
            break;
          case 2:
            reader.onload = (e) => {
              this.template.imgSixthPageC = e.target.result;
            };
            break;
          case 3:
            reader.onload = (e) => {
              this.template.imgSixthPageD = e.target.result;
            };
            break;
        }
      }
      this.show = !this.show;
    },

    add() {
      this.template.eletricos.push({
        item: this.template.eletricos.length + 1,
        descricao: this.eletrico.descricao,
        avaliacao: this.eletrico.avaliacao,
      });
    },

    del() {
      if (this.template.eletricos.length > 0) {
        this.template.eletricos.pop();
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
